import { useState, useContext } from "react";
import { AuthContext } from "../Context/AuthContext";

const defaultForm = {
  passwordCurrent: "",
  password: "",
  confirmPassword: "",
};

const useCustomerchangepass = () => {
  const { token } = useContext(AuthContext);
  const [formData, setFormData] = useState(defaultForm);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [showPass, setShowpass] = useState(false);
  const [showPass2, setShowpass2] = useState(false);
  const [showPass3, setShowpass3] = useState(false);

  const { passwordCurrent, password, confirmPassword } = formData;

  const validateForm = () => {
    if (!passwordCurrent || passwordCurrent.length < 6) {
      setError("Old Password is required and must be at least 6 characters");
      return false;
    }

    if (!password || password.length < 6) {
      setError("New Password is required and must be at least 6 characters");
      return false;
    }

    if (!confirmPassword || confirmPassword.length < 6) {
      setError(
        "Confirm Password is required and must be at least 6 characters"
      );
      return false;
    }

    setError(null);
    return true;
  };

  const handShowpass = () => {
    setShowpass(!showPass);
  };

  const handShowpass2 = () => {
    setShowpass2(!showPass2);
  };

  const handShowpass3 = () => {
    setShowpass3(!showPass3);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setError(null);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/auth/updatePassword/charterer`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );
      const resData = await res.json();
      if (!res.ok) {
        throw new Error(resData.message);
      }
      setLoading(false);
      setSuccess("Password updated successfully");
      setTimeout(() => {
        setSuccess(null);
      }, 3000);
    } catch (error) {
      console.error("Password update error:", error);
      setError(error.message);
      setLoading(false);
    }
  };

  return {
    handleChange,
    handleFormSubmit,
    loading,
    password,
    passwordCurrent,
    confirmPassword,
    error,
    success,
    handShowpass,
    showPass,
    handShowpass2,
    showPass2,
    handShowpass3,
    showPass3
  };
};

export default useCustomerchangepass;
